// extracted by mini-css-extract-plugin
export default {"container":"ProfilePage_container__KwBB1"};